/**
 * Builders for deep link paths used by the notification composer and
 * consumed by the mobile app's React Navigation `linking` config. Kept on
 * the admin side as a single source of truth so the dropdown options stay
 * in sync with the schemes the mobile app parses.
 */

const SCHEME = "com.serenica.eventplanner://";

export function eventDeepLink(eventId: string): string {
  return `${SCHEME}events/${eventId}`;
}

export function sessionDeepLink(eventId: string, sessionId: string): string {
  return `${SCHEME}events/${eventId}/sessions/${sessionId}`;
}

export function surveyDeepLink(eventId: string, surveyId: string): string {
  return `${SCHEME}events/${eventId}/surveys/${surveyId}`;
}

export function inboxDeepLink(): string {
  return `${SCHEME}inbox`;
}

export interface DeepLinkOption {
  value: string;
  label: string;
}

/**
 * Build the list of deep link dropdown options for the compose form.
 * Includes "no deep link" as the first option, the event itself, and every
 * session in the event. Keep session labels short so the dropdown stays
 * readable in the preview pane.
 */
export function buildDeepLinkOptions(
  eventId: string,
  sessions: { id: string; title: string }[],
): DeepLinkOption[] {
  return [
    { value: "", label: "— No deep link —" },
    { value: eventDeepLink(eventId), label: "Event home" },
    ...sessions.map((s) => ({
      value: sessionDeepLink(eventId, s.id),
      label: `Session: ${s.title}`,
    })),
  ];
}
